module.exports = __webpack_public_path__ + "img/blue-delete.f94910c9.svg";